
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApprovalState, VisitorManagementApprovalCompleted, VisitorManagementApprovalRequest, VisitorManagementUiClient } from '../../backend/backendapi';
import CenterOnParent from '../../util/CenterOnParent';
import Spinner from '../../util/Spinner';
import { initClient } from '../../../api';

@Component({
  components: {
    CenterOnParent,
    Spinner,
  },
})
export default class AdvanceRegistrationApprovalComplete extends Vue {
  @Prop({ required: true })
  readonly groupSurveyExtensionId!: string;
  @Prop({ required: true })
  readonly userId!: string | null;
  @Prop({ required: true })
  readonly externalUserId!: string | null;
  @Prop({ required: true })
  readonly action!: ApprovalState;

  result: VisitorManagementApprovalCompleted | null = null;

  private readonly api = initClient(VisitorManagementUiClient);

  ApprovalState = ApprovalState;

  async mounted(): Promise<void> {
    this.result = await this.api.advanceRegistrationApproval(VisitorManagementApprovalRequest.fromJS({
      groupSurveyExtensionId: this.groupSurveyExtensionId,
      userId: this.userId,
      externalUserId: this.externalUserId,
      action: this.action,
    }));
  }
}
